import Reveal, { SectionHeading } from "../components/Reveal";
import { WHAT_WE_MAKE } from "../data";

const ABOUT_IMG = "/img/furnace.jpg";

export default function About() {
  return (
    <section id="about" className="relative py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-20">
          <div>
            <SectionHeading eyebrow="About Us" title={<>Precision, poured & machined in Delhi</>} />
            <Reveal delay={0.15}>
              <div className="mt-7 space-y-5 text-stone-600 leading-relaxed">
                <p>
                  SK Engineering Works, based in Delhi, India, is a manufacturer specialising in
                  Aluminium Pressure Die Casting and precision cast components for industrial,
                  automotive, electrical, engineering and other applications.
                </p>
                <p>
                  With our manufacturing capabilities, machinery and experienced workforce, we
                  undertake component development, die casting, machining, finishing, assembly and
                  customised product development as per customer requirements.
                </p>
                <p>
                  We work with customers from the initial drawing/sample stage through development,
                  production and final supply — with a focus on consistent quality, dimensional
                  accuracy and reliable delivery.
                </p>
              </div>
            </Reveal>
          </div>

          <Reveal delay={0.2}>
            <div className="relative mx-auto max-w-[560px]">
              <div className="absolute -inset-6 rounded-full bg-amber-400/20 blur-[80px]" />
              <div className="relative overflow-hidden rounded-2xl border border-stone-900/10 bg-[#0D1530] shadow-[0_30px_80px_rgba(20,23,28,0.18)]">
                <img
                  src={ABOUT_IMG}
                  alt="Aluminium die casting manufacturing"
                  loading="lazy"
                  className="w-full aspect-[4/3] object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#080C14]/70 via-transparent to-transparent" />
              </div>
              <div className="absolute -bottom-6 left-6 rounded-xl border border-amber-500/40 bg-white/95 px-6 py-4 backdrop-blur-md shadow-[0_18px_40px_rgba(20,23,28,0.12)]" data-testid="about-range-chip">
                <p className="font-display text-2xl font-bold uppercase text-molten">50 g – 800 g</p>
                <p className="mt-0.5 font-tech text-[10px] uppercase tracking-[0.2em] text-stone-500">
                  Die-cast component range
                </p>
              </div>
            </div>
          </Reveal>
        </div>

        <div className="mt-24">
          <Reveal>
            <p className="eyebrow mb-6 flex items-center gap-3">
              <span className="inline-block h-px w-10 bg-amber-600/70" />
              What we manufacture
            </p>
          </Reveal>
          <div className="flex flex-wrap gap-3" data-testid="what-we-manufacture-chips">
            {WHAT_WE_MAKE.map((item, i) => (
              <Reveal key={item} delay={0.04 * i} y={14}>
                <span className="inline-block rounded-full border border-stone-300 bg-white px-5 py-2.5 text-sm text-stone-700 hover:border-amber-500 hover:text-amber-800 transition-colors">
                  {item}
                </span>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
